import { HStack, IconButton, Link, Text, VStack, Box } from "@chakra-ui/react";
import { useState, useRef } from "react";
import { BsHeart } from "react-icons/bs";
import { Tooltip } from "@chakra-ui/react";
import { Skeleton, SkeletonCircle, SkeletonText } from "@chakra-ui/react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";

const SkeletonManage = ({}) => {
  return (
    <>
      <Card
        mt={"30px"}
        direction={{ base: "column", sm: "row" }}
        overflow="hidden"
        variant="outline"
        position="relative"
      >
        <Box position="relative" w="" class="image-wrapper profile-pic">
          <Skeleton top="0px" w="180px" h="230px" alt="normal" />
        </Box>

        <Stack w="100%">
          <CardBody>
            <SkeletonText mt='20px'></SkeletonText>
            <SkeletonText mt='20px'></SkeletonText>
            <SkeletonText mt='20px'></SkeletonText>
            <Divider />
          </CardBody>
        </Stack>
      </Card>
    </>
  );
};

export { SkeletonManage };
